import { compose, connect, bindActionCreators, injectIntl, debounce } from '../dependencies';

import TagListFilter from '../components/TagListFilter';

import { FILTER_DEBOUNCE_TIME } from '../constants';
import { setFilter } from '../services/actions';

export default compose(
    connect(
        null,
        dispatch => ({
            onChange: debounce(bindActionCreators(setFilter, dispatch), FILTER_DEBOUNCE_TIME),
        }),
    ),
    injectIntl,
)(TagListFilter);
